import React, { Component } from 'react';
import { Type } from 'react-spark';

export class OffersV2Disclaimer extends Component {
    render() {
        return (
            <Type.BodyFour
                className="antialiased sprk-u-pvm sprk-u-man"
                style={{ lineHeight: 1.375 }}>
                *Your prequalified loan offers are valid for 5 days from{' '}
                the date you submitted your inquiry. The terms above are{' '}
                subject to you selecting an offer and either signing up{' '}
                with or logging into Rocket Account, after which you can{' '}
                continue with the rest of your application. If you do not{' '}
                take such action within 5 days, your offers will expire and{' '}
                you will need to resubmit your information. The payment, rate,{' '}
                APR, and any finance charges are all estimates based upon your{' '}
                stated income and credit profile. If your income is verified to{' '}
                be less than your stated income and/or other factors in your{' '}
                credit profile change, your loan offers may also change. Selecting{' '}
                a loan offer does not commit you to a loan.
            </Type.BodyFour>
        );
    }
}
